module.exports = __webpack_public_path__ + "static/media/capture.f825e344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/capture.jpg
// module id = 1787
// module chunks = 3